import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "node-start",
  "use": "node-start-usage",
  "viewBox": "0 0 20 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 24\" id=\"node-start\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M1 15.3s1.1-1.1 4.4-1.1 5.5 2.2 8.8 2.2 4.4-1.1 4.4-1.1V2.1s-1.1 1.1-4.4 1.1S8.7 1 5.4 1 1 2.1 1 2.1zm0 0V23\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol